import { ajaxAuth } from "@tm/utils"
import { CompilationsFindResponse } from ".."
import { WebserviceUrl } from "../../webserviceUrls"

export function findCompilationsWM(query?: string, pageIndex?: number, pageSize?: number) {
    const url = `${WebserviceUrl.CompilationsArticleCompilationsWm}/CompilationsFind`
    const body = { query, pageIndex, pageSize }

    return ajaxAuth<CompilationsFindResponse>({ url, body }, undefined, undefined, true)
}
